/*
 * Copyright (c) 2025 curryfirm.com
 */

const normalizeRouteResponse = (response) => {

    // Flatten routes by index.
    const routes = {};
    response.routeApiJsonResult.routes.forEach((route, i) => {
        // Pull out all top-level fields except `legs`
        const { legs, ...routeRest } = route;
        routes[i] = { ...routeRest, legIds: legs.map((_, j) => `${i}_${j}`) };
    });

    // Flatten legs and add links to parent route.
    const legs = {};
    response.routeApiJsonResult.routes.forEach((route, i) => {
        route.legs.forEach((leg, j) => {
            // Pull out all fields except `steps`
            const { steps, ...legRest } = leg;
            legs[`${i}_${j}`] = { ...legRest, routeId: i, stepIds: steps.map((_, k) => `${i}_${j}_${k}`) };
        });
    });

    // Flatten steps and add links to parent leg.
    const steps = {};
    response.routeApiJsonResult.routes.forEach((route, i) => {
        route.legs.forEach((leg, j) => {
            leg.steps.forEach((step, k) => {
                steps[`${i}_${j}_${k}`] = { ...step, legId: `${i}_${j}` };
            });
        });
    });

    // Assign geocoding and fallbackInfo directly.
    const geocoding = Array.isArray(response.routeApiJsonResult.geocodingResults)
        ? Object.fromEntries(
            response.routeApiJsonResult.geocodingResults.map((res, idx) => [idx, res])
        )
        : {};

    const fallbackInfo = response.fallbackInfo ?? {};

    // Return normalized output.
    return {
        optimalRoute: response.routeApiJsonResult,   // Optionally, for reference
        routes,                   // Flattened map: { routeId: route }
        legs,                     // Flattened map: { legId: leg }
        steps,                    // Flattened map: { stepId: step }
        geocoding,                // Map by order or key, as above
        fallbackInfo,             // As returned from API
        moves : response.moves,
        totalLength : response.totalLength,  // Duration in seconds
    };
};

export default normalizeRouteResponse;

